// Order of utility-ng-log is important don't sort.
require('angular-ui-router');
require('angular-aria');
import 'ui-ng-ax';
import 'ui-ng-modal';
import 'utility-ng-log';
import 'utility-ng-auth-token';
import 'utility-ng-configuration';
import 'utility-ng-enumeration';
import 'utility-ng-interface';
import 'utility-ng-kernel';
import 'utility-ng-network-cache';
import 'utility-ng-progression';
import 'utility-ng-time';
import 'utility-ng-type';
import 'ui-ng-popover';
import 'ui-ng-component-communicator';
import 'ui-ng-delegate';
import 'ui-ng-draggable';
import 'ui-ng-drag-drop';
import 'ui-ng-feature';
import 'ui-ng-smooth-scroll';
import 'ui-ng-university-branding';
import 'ui-ng-university-text';
import 'ui-ng-sticky';
import 'utility-ts-orm';
import 'data-ng-custom-text';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/vendor.ts